export default __webpack_public_path__ + "static/LeituraTwo-BoldItalic-6985e2937681d0bec8714ea76f6472b9.woff";